var React = require('react');

function Like (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5133 16.9998C10.5044 17.0001 10.4958 17.0001 10.4869 16.9998C10.3857 16.9998 10.2834 16.9711 10.1944 16.9108C9.91356 16.7211 3.28492 12.219 0.842661 8.42119C0.839382 8.41606 0.836337 8.41093 0.833058 8.4058C0.288069 7.54495 0 6.55653 0 5.54603C0 2.488 2.61276 0 5.82415 0C7.68348 0 9.41002 0.841227 10.5 2.23844C11.59 0.841227 13.3168 0 15.1759 0C18.3872 0 21 2.488 21 5.54603C21 6.55653 20.7119 7.54495 20.1669 8.4058C20.1639 8.41093 20.1609 8.41606 20.1573 8.42119C17.7153 12.219 11.0867 16.7211 10.8056 16.9108C10.7171 16.9711 10.6148 16.9998 10.5133 16.9998Z","fill":"currentColor"}));
}

Like.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = Like;

Like.default = Like;
